import { useEffect, useState } from "react";

const links = [
  { label: "合集大全", href: "#collections" },
  { label: "分类导览", href: "#catalog" },
  { label: "人物档案", href: "#archives" },
  { label: "时间线", href: "#timeline" },
  { label: "专题研究", href: "#specials" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50 transition-all duration-300">
      <div
        className={
          scrolled
            ? "border-b border-ink/10 bg-cream/90 backdrop-blur-md"
            : "bg-transparent"
        }
      >
        <div className="shell-wrap flex h-[64px] items-center justify-between gap-4">
          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-ember text-lg font-black text-white">
              91
            </span>
            <span className="title-serif text-xl md:text-2xl font-black leading-none">
              黑料
            </span>
          </a>

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 lg:flex">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="rounded-full px-3.5 py-2 text-sm font-medium text-ink/80 transition-colors hover:bg-ink/5 hover:text-ink cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#hero"
              className="hidden whitespace-nowrap rounded-full bg-ember px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-ink sm:inline-flex"
            >
              今日热议
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-ink/15 bg-paper text-lg text-ink lg:hidden cursor-pointer"
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="anchor-panel border-t border-ink/10 bg-cream/95 backdrop-blur-md lg:hidden">
            <nav className="shell-wrap flex flex-col py-3">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-2 py-3 text-sm font-medium text-ink/80 hover:bg-ink/5"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}